// extracted by mini-css-extract-plugin
export default {"title":"OtpVerification_title__C-PX3","container":"OtpVerification_container__PdCm7","buttons":"OtpVerification_buttons__35UZ0"};